<div>
    <div class="page-title">{{ localizationKeys.aumico_reports_reset_password_forgot_password_title | i18next}}</div>
    <div class="page-shortIntroduction">{{ localizationKeys.aumico_reports_reset_password_introduction | i18next}}</div>
</div>
<div>
    <form class="form" [formGroup]="resetForm">
        <div class="form-group">
            <div class="input-wrapper">
                <input
                    hamInput
                    label="{{localizationKeys.aumico_reports_reset_password_forgot_email_username | i18next}}"
                    id="userName"
                    class="form-control"
                    type="text"
                    formControlName="userName"
                    [placeholder]="localizationKeys.aumico_reports_input_please_enter_placeholder | i18next"
                />
            </div>
        </div>

        <div class="errorMessages">
            <span class="unauthorized" *ngIf="isResetFailed"
                >{{localizationKeys.aumico_reports_reset_password_credentials_error | i18next}}</span
            >
            <span class="unauthorized" *ngIf="isBadRequest">{{badRequestErrorMessage}}</span>
            <span class="unauthorized" *ngIf="isServerError"
                >{{localizationKeys.aumico_errors_server_error | i18next}}</span
            >
        </div>

        <div class="action-buttons">
            <ham-button id="resetButton" [disabled]="buttonStatus()" (buttonClick)="onResetAccount()">
                {{ 'aumico_reports_reset_password_forgot_send_instruction_button' | i18next}}
            </ham-button>
        </div>
    </form>
</div>
